import { combineReducers, configureStore } from "@reduxjs/toolkit";
import mondayReducer from "../slices/mondaySlice";
import listReducer from "../slices/listSlice"; // Import the list slice
import accessTokenReducer from "../slices/accessTokenSlice";
import targetBoardNameReducer from "../slices/onboardingTargetBoardNameSlice";
import addItemSusccesReducer from "../slices/addItemSuccessSlice";
import itemConnectedReducer from "../slices/itemConnectedSlice";

export const rootReducer = combineReducers({
  monday: mondayReducer,
  list: listReducer,
  accessToken: accessTokenReducer,
  targetBoardName: targetBoardNameReducer,
  addItemSuccess: addItemSusccesReducer,
  itemConnected: itemConnectedReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

/**
 * Builds an isolated store. The app uses the `store` singleton below; tests use
 * this so state cannot leak from one test into the next.
 */
export const createAppStore = (preloadedState?: Partial<RootState>) =>
  configureStore({ reducer: rootReducer, preloadedState });

export const store = createAppStore();

export type AppDispatch = typeof store.dispatch;
